import React from "react";

import { Button } from "antd";

import { goTo, trackMixpanel, useNavigate } from "utils";

import { Icon, Typography } from "components";

/**
 * <CTAButton/>
 *
 * @param   {string} text to display on the button
 * @param   {string} icon ["camera","filePlus", "newItem", "apps", "applyToField", "edit", "funding"]
 * @param   {string} url to navigate to
 * @param   {React.MouseEventHandler<HTMLElement>} onClick onClick
 * @param   {boolean} disabled disabled
 * @param   {string} dataTestId dataTestId
 * @param   {CSSProperties} style style
 * @return  {ReactElement} AntButton
 */

type CTAButtonProps = {
  text: string;
  icon: string;
  url?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
  dataTestId?: string;
  style?: React.CSSProperties;
};

export const CTAButton = ({ icon, url, text, style, onClick, dataTestId, disabled }: CTAButtonProps) => {
  const navigate = useNavigate();
  const getIcon = () => {
    if (icon === "eye") {
      return <Icon iconName="tabler/eye" size="m" className="icon inline" />;
    }
    if (icon === "camera") {
      return <Icon iconName="tabler/camera" size="m" className="icon inline" />;
    }
    if (icon === "filePlus") {
      return <Icon iconName="tabler/file-plus" size="m" className="icon inline" />;
    }
    if (icon === "newItem") {
      return <Icon iconName="tabler/layout-grid-add" size="m" className="icon inline" />;
    }
    if (icon === "apps") {
      return <Icon iconName="tabler/apps" size="m" className="icon inline" />;
    }
    if (icon === "applyToField") {
      return <Icon iconName="klim/field-apply" size="m" className="icon inline" />;
    }
    if (icon === "edit") {
      return <Icon iconName="tabler/edit" size="m" className="icon inline" />;
    }
    if (icon === "funding") {
      return <Icon iconName="klim/funding" size="m" className="icon inline" />;
    }
    if (icon === "timelineEventPlus") {
      return <Icon iconName="tabler/timeline-event-plus" size="m" className="icon inline" />;
    }
    if (icon === "funding") {
      return <Icon iconName="klim/funding" size="m" className="icon inline" />;
    }

    return <Icon iconName="klim/plus" size="m" className="icon inline" />;
  };

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    trackMixpanel("ClickButton", { buttonText: text });
    if (onClick) {
      onClick(e);
    } else {
      goTo(e, navigate, url);
    }
  };

  return (
    <Button data-testid={`${dataTestId}-CTA-button`} className="cta-button" onClick={handleClick} style={style} disabled={disabled}>
      {getIcon()}
      <Typography variant="paragraph-m">{text}</Typography>
    </Button>
  );
};
